import classes from "./divider.module.css";
import { IconLogoMarkLightSmall } from "../icons";

const Divider = () => {
  return (
    <div className={classes.marketing__divider}>
      <IconLogoMarkLightSmall className={classes.marketing__divider_icon} />
    </div>
  );
};

export { Divider };
